import * as React from "react";
const SvgEditIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 21"
    {...props}>
    <path
      stroke={props.stroke || "#464A4D"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="m11.055 4.783-6.841 7.241c-.259.275-.509.817-.559 1.192l-.308 2.7c-.108.975.592 1.642 1.558 1.475l2.684-.458c.375-.067.9-.342 1.158-.625l6.842-7.242c1.183-1.25 1.716-2.675-.125-4.417-1.834-1.725-3.225-1.116-4.409.134Z"
    />
    <path
      stroke={props.stroke || "#464A4D"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M9.914 5.991a5.105 5.105 0 0 0 4.542 4.292"
    />
  </svg>
);
export default SvgEditIcon;
